// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as $$String from "../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as CardTitleWithImage from "./CardTitleWithImage.bs.js";
import * as NLOrderContactInfoVm from "./vm-mapper/NLOrderContactInfoVm.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as OrderDashboardAssetsManager from "../../../assets/OrderDashboardAssetsManager.bs.js";

var contact_icon = OrderDashboardAssetsManager.getImage("contact.svg");

function getViewLabel(contact_info) {
  var initial_list_0 = {
    label: "Booking Number",
    value: {
      TAG: /* Text */0,
      _0: contact_info.booking_number
    }
  };
  var initial_list_1 = {
    hd: {
      label: "Receiver Contact",
      value: {
        TAG: /* Text */0,
        _0: contact_info.receiver_contact
      }
    },
    tl: {
      hd: {
        label: "Sender Contact Number",
        value: {
          TAG: /* Text */0,
          _0: contact_info.sender_contact
        }
      },
      tl: {
        hd: {
          label: "Partner Mobile Number",
          value: {
            TAG: /* Text */0,
            _0: contact_info.partner_mobile_number
          }
        },
        tl: {
          hd: {
            label: "Goods Type",
            value: {
              TAG: /* Text */0,
              _0: contact_info.goods_type
            }
          },
          tl: {
            hd: {
              label: "Partner Secondary Number",
              value: {
                TAG: /* Text */0,
                _0: contact_info.partner_secondary_number
              }
            },
            tl: /* [] */0
          }
        }
      }
    }
  };
  var initial_list = {
    hd: initial_list_0,
    tl: initial_list_1
  };
  var match = process.env.INFRA_STACK;
  if (match === "india") {
    return List.concat({
                hd: initial_list,
                tl: {
                  hd: {
                    hd: {
                      label: "Delivery Instructions",
                      value: {
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            var val = List.length(contact_info.delivery_instructions);
                            if (val > 0 && $$String.trim(List.hd(contact_info.delivery_instructions)) === "" || val <= 0) {
                              return "N/A";
                            } else {
                              return $$String.trim(List.hd(contact_info.delivery_instructions));
                            }
                          })
                      }
                    },
                    tl: /* [] */0
                  },
                  tl: /* [] */0
                }
              });
  } else {
    return initial_list;
  }
}

function NLOrderContactInfo(Props) {
  var order = Props.order;
  var contact_info = NLOrderContactInfoVm.getVm(order);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Contact Information",
                                icon_src: contact_icon
                              });
                  })
              },
              action: undefined,
              className: "primary-info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(contact_info))
                  })
            });
}

var make = NLOrderContactInfo;

export {
  contact_icon ,
  getViewLabel ,
  make ,
  
}
/* contact_icon Not a pure module */
